import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText, useToast } from '@morressier/alembic';
import { removeDraftSubmission } from 'src/api/mutations';
import DeleteDraftModal from './DeleteDraftModal';
import { allowSubmissionNavigationWithoutPrompt } from './SubmissionLeaveGuard';

interface Props {
  submissionId: string;
  submissionContextId: string;
  isDisabled?: boolean;
}

const DeleteDraft: React.FC<Props> = ({
  submissionId,
  submissionContextId,
  isDisabled
}) => {
  const toast = useToast();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const removeDraftMutation = removeDraftSubmission();

  const onDeleteDraft = async () => {
    const res = await removeDraftMutation.mutateAsync({
      submissionContextId,
      submissionId
    });
    if (res && res.isSuccess) {
      toast({
        variant: 'success',
        title: 'Draft Deleted',
        isClosable: true
      });

      setIsOpen(false);
      allowSubmissionNavigationWithoutPrompt();
      return navigate('/app/my-submissions');
    }

    return toast({
      variant: 'error',
      title: 'Draft Delete Unsuccessful',
      description:
        'We encountered an issue while deleting your draft submission. Please try again.',
      isClosable: true
    });
  };

  return (
    <>
      <ButtonText
        variant="caution"
        onClick={() => setIsOpen(true)}
        leftIcon={<FontAwesomeIcon icon={faTrash} />}
        isDisabled={isDisabled}
      >
        Delete Draft
      </ButtonText>

      <DeleteDraftModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onRemove={onDeleteDraft}
        isLoading={removeDraftMutation.isLoading}
      />
    </>
  );
};

export default DeleteDraft;
